module.exports = __webpack_public_path__ + "static/media/psd.a4289765.svg";